export enum Gender {
  Male = 'Male',
  Female = 'Female',
}

export enum ViewBy {
  Future = 'Future',
  Past = 'Past',
}
